import { rootApi } from '../rootApi';

const getAcceptLanguage = () => {
    try {
        const savedLanguage = localStorage.getItem('selectedLanguage');
        if (savedLanguage) {
            const languageData = JSON.parse(savedLanguage);
            const localeMap = { TR: 'TR', US: 'US', DE: 'DE', FR: 'FR', IT: 'IT', RO: 'RO' };
            return localeMap[languageData.code] || 'US';
        }
    } catch {
        // ignore parse errors
    }
    return 'US';
};

const withLanguageHeader = (query) => ({
    ...query,
    headers: {
        ...(query.headers || {}),
        'Accept-Language': getAcceptLanguage()
    }
});

export const partsDealerBrandMatchApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getPartsDealerBrandMatchList: builder.query({
            query: (params = {}) =>
                withLanguageHeader({
                    url: 'v1/PartsDealerBrandMatch/GetList',
                    method: 'GET',
                    params: {
                        pageNumber: params.pageNumber ?? 1,
                        pageSize: params.pageSize ?? 10,
                        languageId: params.languageId ?? 1,
                        dealerId: params.dealerId || undefined,
                        brand: params.brand || undefined,
                        isVisible: params.isVisible ?? undefined,
                        dealerType: params.dealerType ?? undefined,
                        searchText: params.searchText || undefined,
                        sortField: params.sortField || undefined,
                        sortOrder: params.sortOrder || undefined,
                        activeOnly: params.activeOnly ?? 1
                    }
                }),
            transformResponse: (response) => ({
                items: response?.data?.items ?? [],
                totalCount: response?.data?.totalCount ?? 0
            }),
            providesTags: ['PartsDealerBrandMatch']
        }),
        getPartsDealerBrandMatchById: builder.query({
            query: ({ id, languageId }) =>
                withLanguageHeader({
                    url: 'v1/PartsDealerBrandMatch/GetById',
                    method: 'GET',
                    params: {
                        id,
                        languageId: languageId ?? 1
                    }
                }),
            transformResponse: (response) => response?.data ?? null,
            providesTags: (result, error, arg) => [{ type: 'PartsDealerBrandMatch', id: arg?.id }]
        }),
        getPartsDealerBrandMatchDealerDropdown: builder.query({
            query: ({ searchText } = {}) =>
                withLanguageHeader({
                    url: 'v1/PartsDealerBrandMatch/GetDealerDropdown',
                    method: 'GET',
                    params: {
                        searchText: searchText || undefined
                    }
                }),
            transformResponse: (response) => {
                if (Array.isArray(response?.data)) return response.data;
                if (Array.isArray(response)) return response;
                return [];
            }
        }),
        getPartsDealerBrandMatchBrandDropdown: builder.query({
            query: ({ searchText } = {}) =>
                withLanguageHeader({
                    url: 'v1/PartsDealerBrandMatch/GetBrandDropdown',
                    method: 'GET',
                    params: {
                        searchText: searchText || undefined
                    }
                }),
            transformResponse: (response) => {
                if (Array.isArray(response?.data)) return response.data;
                if (Array.isArray(response)) return response;
                return [];
            }
        }),
        savePartsDealerBrandMatch: builder.mutation({
            query: (body) =>
                withLanguageHeader({
                    url: 'v1/PartsDealerBrandMatch/Save',
                    method: 'POST',
                    body
                }),
            transformResponse: (response) => response,
            invalidatesTags: ['PartsDealerBrandMatch']
        }),
        updatePartsDealerBrandMatchVisibility: builder.mutation({
            query: (body) =>
                withLanguageHeader({
                    url: 'v1/PartsDealerBrandMatch/Update',
                    method: 'POST',
                    body
                }),
            transformResponse: (response) => response,
            invalidatesTags: ['PartsDealerBrandMatch']
        }),
        deletePartsDealerBrandMatch: builder.mutation({
            query: (id) =>
                withLanguageHeader({
                    url: 'v1/PartsDealerBrandMatch/Delete',
                    method: 'DELETE',
                    body: { id }
                }),
            transformResponse: (response) => response,
            invalidatesTags: ['PartsDealerBrandMatch']
        })
    }),
    overrideExisting: false
});

export const {
    useGetPartsDealerBrandMatchListQuery,
    useGetPartsDealerBrandMatchByIdQuery,
    useGetPartsDealerBrandMatchDealerDropdownQuery,
    useGetPartsDealerBrandMatchBrandDropdownQuery,
    useSavePartsDealerBrandMatchMutation,
    useUpdatePartsDealerBrandMatchVisibilityMutation,
    useDeletePartsDealerBrandMatchMutation
} = partsDealerBrandMatchApi;
